import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Checkbox,
  Button,
} from "antd";
import "./enterbill.css";
import { FaDollarSign } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import { propertiesData, GLAccountsData } from "./enterBillData";
import Notes from "../../../../../components/common/Notes";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import RightBar from "../../../../../components/common/RightBar";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";

const EnterBillRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Smart Bill Entry", "1", "", "", "/accounting/payables_bills/bills/smartbillentry"),
  ]),
  RightBarMethod(
    "Reports",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [RightBarMethod("Vendor Ledger", "2", "", "", "")]
  ),
  RightBarMethod(
    "HELP TOPICS",
    "t4",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("Enter a Bill", "3", "", "", "")]
  ),
];

const EnterBill = () => {
  const [payee, setPayee] = useState("");
  const [isAllocation, setIsAllocation] = useState(false);
  const [unit, setUnit] = useState(null);
  const [amount, setAmount] = useState(0);
  const [inputValues, setInputValues] = useState([]);

  const onChange = (value) => {
    console.log(`selected ${value}`);
    setPayee(value);
  };

  const handleAllocation = (e) => {
    setIsAllocation(e.target.checked);
    console.log(`checked = ${e.target.checked}`);
  };

  const initialList = [{ id: uuidv4() }];

  const [accounts, setAccounts] = useState(initialList);

  useEffect(() => {
    const newTotal = Object.values(inputValues).reduce(
      (total, value) => total + Number(value),
      0
    );
    setAmount(newTotal);
  }, [inputValues]);

  function handleAddAccount() {
    const newList = accounts.concat({ id: uuidv4() });
    setAccounts(newList);
  }

  function handleRemoveAccount(id) {
    const newList = accounts.filter((item) => item.id !== id);
    setAccounts(newList);
  }

  const handleBillDetailsProperty = (value) => {
    setAmount(0);
    const selectTed = propertiesData.find((item) => item.value === value);
    setUnit(selectTed);
  };

  const handleAvailableAmount = (e) => {
    const newValue = Number(e.target.value);
    if (!isNaN(newValue)) {
      setInputValues({ ...inputValues, [e.target.id]: e.target.value });
    }
  };
  return (
    <div>
      <div className="pageheading ">
        <h1>New Bill</h1>
        <div className="pageHeadingBtns">
          <button>Repeat Bill</button>
        </div>
      </div>
      <Form
        name="basic"
        initialValues={{
          remember: true,
        }}
        autoComplete="off"
        layout="vertical"
      >
        <Card>
          <Row gutter={16}>
            <Col span={9}>
              <Form.Item required>
                <div className="labelForPay">
                  <label htmlFor="payee" required>
                    Payee
                  </label>
                  <a href="/people/vendors/new">Add New Vendor</a>
                </div>
                <Select
                  showSearch
                  allowClear
                  placeholder="Start typing to search"
                  optionFilterProp="children"
                  onChange={onChange}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value:
                        "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
                      label:
                        "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
                    },
                    {
                      value:
                        "A New Creation L.L.C. - 11711 Lorene Ave  Midwest City, OK 73130",
                      label:
                        "A New Creation L.L.C. - 11711 Lorene Ave  Midwest City, OK 73130",
                    },
                    {
                      value: "AT&T - PO Box 5014  Carol Stream, IL 60197",
                      label: "AT&T - PO Box 5014  Carol Stream, IL 60197",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item label="Total Amount" required>
                <Input
                  placeholder="Amount"
                  addonBefore={<FaDollarSign size={12} />}
                  defaultValue={(Math.round(amount * 100) / 100).toFixed(2)}
                  onChange={handleAvailableAmount}
                  id={accounts.length < 2 ? 0 : "totalAmount"}
                  value={inputValues.value}
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item label="Bill Date" required>
                <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item label="Due Date" required>
                <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={9}>
              <Col span={12}>
                <p>{payee}</p>
              </Col>
            </Col>
            <Col span={5}>
              <Form.Item label="Posting Date">
                <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={5} offset={9}>
              <Form.Item label="Work Order">
                <Select
                  showSearch
                  allowClear
                  placeholder="Start typing to search"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={propertiesData}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={5} offset={9}>
              <Form.Item label="Reference">
                <Input placeholder="e.g. Invoice #123" />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="Remarks">
                <Input placeholder="e.g. November Bill" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={5} offset={9}>
              <Form.Item label="Cash Account">
                <Select
                  showSearch
                  allowClear
                  placeholder="Automatic"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      label: "Cash",
                      options: [
                        {
                          label: "23291: Rental Income Account",
                          value: "23291: Rental Income Account",
                        },
                        {
                          label: "23292: Security Deposits Bank Account",
                          value: "23292: Security Deposits Bank Account",
                        },
                      ],
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="Memo for Check">
                <Input placeholder="e.g. Account #123456" />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <br />
        <Card>
          <Form.Item>
            <Checkbox onChange={handleAllocation}>
              <b>Allocation</b>
            </Checkbox>
          </Form.Item>
          {isAllocation ? (
            <Row gutter={16}>
              <Col span={9}>
                <Form.Item label="Properties">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Search by group, owner, portfolio"
                    optionFilterProp="children"
                    onChange={onChange}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={propertiesData}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="GL Account">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Start typing to search"
                    optionFilterProp="children"
                    onChange={onChange}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={GLAccountsData}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="Description">
                  <Input placeholder="e.g. Landscaping" />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="Allocation Type">
                  <Select
                    optionFilterProp="children"
                    onChange={onChange}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        value: "Unit Count",
                        label: "Unit Count",
                      },
                      {
                        value: "Square Feet",
                        label: "Square Feet",
                      },
                      {
                        value: "Rental Income",
                        label: "Rental Income",
                      },
                      {
                        value: "Even Spread",
                        label: "Even Spread",
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
          ) : (
            ""
          )}
        </Card>
        <br />
        <Card title="Bill Details">
          <ul>
            {accounts.map((item, index) => (
              <li key={item.id}>
                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item label="Property" required>
                      <Select
                        showSearch
                        allowClear
                        placeholder="Start typing to search"
                        style={{ width: "100%" }}
                        options={propertiesData}
                        onChange={handleBillDetailsProperty}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item label="Unit">
                      <Select
                        showSearch
                        allowClear
                        style={{ width: "100%" }}
                        options={unit?.units}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="GL Account" required>
                      <Select
                        showSearch
                        allowClear
                        placeholder="Start typing to search"
                        style={{ width: "100%" }}
                        options={GLAccountsData}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item label="Description">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item label="Amount" className="EnterBillAmount">
                      <Input
                        placeholder="Amount"
                        addonBefore={<FaDollarSign size={12} />}
                        defaultValue={(Math.round(0 * 100) / 100).toFixed(2)}
                        onChange={handleAvailableAmount}
                        id={index}
                        value={
                          accounts.length < 2
                            ? (Math.round(amount * 100) / 100).toFixed(2)
                            : inputValues.value
                        }
                        style={{ textAlign: "right" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={1}>
                    {accounts.length > 1 ? (
                      <Form.Item label=" ">
                        <Button
                          className="roundSmallButton"
                          onClick={() => {
                            handleRemoveAccount(item.id);
                          }}
                          type="primary"
                          shape="circle"
                          icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                          size={"small"}
                        />
                      </Form.Item>
                    ) : (
                      <></>
                    )}
                  </Col>
                </Row>
              </li>
            ))}

            <Form.Item label="">
              <Button
                className="addPropertyGroupButton"
                type="primary"
                onClick={handleAddAccount}
                size={"small"}
                icon={<i className="fa-solid fa-circle-plus"></i>}
              >
                {" "}
                Add Another Line
              </Button>
            </Form.Item>

            <Row>
              <Col span={18}></Col>
              <Col span={4}>
                <h4>Total: </h4>
              </Col>
              <Col span={2}>
                <h4>${(Math.round(amount * 100) / 100).toFixed(2)} </h4>
              </Col>
            </Row>
          </ul>
        </Card>
      </Form>
      <br />
      <Row gutter={16}>
        <Col>
          <Button type="primary">Save & Add Another</Button>
        </Col>
        <Col>
          <Button>Save</Button>
        </Col>
        <Col>
          <Button type="link">Cancel</Button>
        </Col>
      </Row>
      <br />
      <Row gutter={[0, 24]}>
        <Col span={24}>
          {/* <Notes /> */}
        </Col>
        <Col span={24}>
          {/* <AttachmentsUpload /> */}
        </Col>
      </Row>
      <div className="RightSidebar">
        <RightBar RightBarData={EnterBillRightBar} />
      </div>
    </div>
  );
};

export default EnterBill;
